import type { ModuleListener, UiModule } from '@krp/client-runtime'

import { PLATFORM_ACTIONS } from './actions/registerActions'
import { platformLiveHandlers } from './features/resources/api/liveHandlers'
import { createResourcesListeners } from './features/resources/model/listeners'
import type { ResourcesPortsFactory } from './features/resources/model/ports'
import { createSearchListeners } from './features/search/model/listeners'
import type { SearchPortsFactory } from './features/search/model/ports'
import { platformUiReducer, type PlatformUiState } from './state'
import { platformWindows } from './windows/registerWindows'

/** Порты всех фич пакета: их реализует composition приложения. */
export interface PlatformUiPorts {
  resources: ResourcesPortsFactory
  search: SearchPortsFactory
}

/**
 * Модуль пакета для composition. Приложение подключает его одной строкой и
 * передаёт порты; внутрь пакета для этого не заглядывает.
 */
export function createPlatformUiModule(ports: PlatformUiPorts): UiModule<PlatformUiState> {
  const listeners: ModuleListener<PlatformUiState>[] = [
    ...createResourcesListeners<PlatformUiState>(ports.resources),
    ...createSearchListeners<PlatformUiState>(ports.search),
  ]
  return {
    id: 'platform',
    reducer: platformUiReducer,
    slices: [
      { name: 'access', lifetime: 'screen', reason: 'открытая роль на экране прав; галочки и ответы сервера в slice не кладутся' },
      {
        name: 'commonCatalog',
        lifetime: 'screen',
        reason: 'строка поиска и страница общего каталога — память окна; вкладка окна помнит их снимком, товары — в кэше запросов',
      },
      {
        name: 'scanSession',
        lifetime: 'screen',
        reason: 'счётчик и лента смены сканирования (создано, прикреплено, найдено, пропущено) — память экрана; с закрытием сканера начинается заново',
      },
      {
        name: 'catalogLinks',
        lifetime: 'screen',
        reason: 'черновик связывания карточек и ресурс списка — память окна; связи живут на сервере',
      },
    ],
    windows: platformWindows,
    // UI-ACTIONS-2a: что делает каждая кнопка окон пакета — подсказка ⓘ.
    actions: PLATFORM_ACTIONS,
    // RP-UI-LINK, шаг 3: связь источника меняется без перезагрузки раздела.
    live: platformLiveHandlers,
    persistence: [],
    listeners,
  }
}
